import Vue from 'vue';

import './styles/quasar.scss';
import 'quasar/dist/quasar.ie.polyfills';
import '@quasar/extras/material-icons/material-icons.css';
import '@quasar/extras/fontawesome-v5/fontawesome-v5.css';
import Quasar from 'quasar/src/vue-plugin.js';import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';import Loading from 'quasar/src/plugins/Loading.js';import BottomSheet from 'quasar/src/plugins/BottomSheet.js';import Dialog from 'quasar/src/plugins/Dialog.js';import QToggle from 'quasar/src/components/toggle/QToggle.js';;

Vue.use(Quasar, {
  config: {},
  plugins: {
    Loading,
    BottomSheet,
    Dialog
  },
  components: {
    QExpansionItem,
    QToggle
  }
});
